import React from 'react';

import * as auth from 'services/auth';
import { setMainMenuMode } from 'services/dynamicjson';
import { initializeChat, disconnectChat } from 'services/chat';
import { sendAmplitudeData } from 'util/amplitude';

const AuthContext = React.createContext();

function AuthContextProvider({ children }) {
  const [userData, setUserData] = React.useState(null);
  React.useEffect(() => {
    userData && initializeChat();
  }, [userData]);

  if (!userData) {
    auth.getLoggedInUser().then(setUserData);
  }

  async function login({ phone, otp, remember }) {
    const user = await auth.login({ phone, otp, remember });
    if (user.error) {
      throw user;
    } else {
      return setUserData(user);
    }
  }

  function requestOTP(phone) {
    return auth.requestOTP(phone);
  }

  function loginMagicLink({ magicLinkToken, query }) {
    return auth
      .goto({ magicLinkToken, query })
      .then(({ userData, link, pageType }) => {
        setMainMenuMode('v1'); // TODO: remove this hack, added for supporting older users
        setUserData(userData);
        return { link, pageType };
      });
  }

  function logout() {
    return auth.logout().then(() => {
      setUserData(null);
    });
  }

  return (
    <AuthContext.Provider
      value={{ userData, login, loginMagicLink, logout, requestOTP }}
    >
      {children}
    </AuthContext.Provider>
  );
}

function useAuthContext() {
  const auth = React.useContext(AuthContext);
  if (auth === undefined) {
    throw new Error('useAuthContext must be used within a AuthContextProvider');
  }
  return { ...auth, loggedIn: !!auth.userData };
}

function useAuthUserContext() {
  const auth = useAuthContext();
  return auth.userData;
}

export { AuthContextProvider, useAuthContext, useAuthUserContext };
